const formatRoleLabel = (value) => {
  if (!value) return '';
  return String(value)
    .replace(/_/g, ' ')
    .trim()
    .replace(/\s+/g, ' ')
    .toLowerCase()
    .replace(/\b\w/g, (char) => char.toUpperCase());
};

export const normalizeVoters = (rawVoters = []) => {
  const seen = new Map();
  const list = [];
  rawVoters.forEach((entry, idx) => {
    const memberId = entry?.memberId || entry?.member_id || entry?.id || null;
    const fullName = (entry?.fullName || entry?.full_name || '').trim();
    const email = (entry?.email || '').trim();
    const role = (entry?.role || entry?.team_role || '').toString().trim();
    const roleLabel = formatRoleLabel(role);
    const key = memberId || email || `${fullName}-${idx}`;
    if (!key || seen.has(key)) return;
    seen.set(key, true);
    list.push({
      memberId,
      fullName,
      email,
      role: roleLabel || '',
    });
  });
  list.sort((a, b) => {
    const nameA = a.fullName || a.email || '';
    const nameB = b.fullName || b.email || '';
    return nameA.localeCompare(nameB);
  });
  return list;
};

// A choice picked in discovery saves its restaurant's menu link in the
// option's description: /restaurant/<id>?sharedView=poll. Until 2026-10-08 it
// was saved with the creating browser's origin in front, so a poll made on a
// dev server, the netlify guest host or another deploy sent everyone there
// (staging QA: "View menu" pointed at http://localhost:5214/restaurant/…).
// New polls save the path alone.
const APP_MENU_PATH = /^\/restaurant\/[^/]+\/?$/;

export const buildPollOptionMenuPath = (restaurantId) =>
  restaurantId ? `/restaurant/${encodeURIComponent(restaurantId)}?sharedView=poll` : '';

// A full link to one of those menus, on any origin, reads as its path (and
// query), so it opens on the origin the reader is using. Anything else comes
// back as it was given.
export const toAppRelativeLink = (rawLink) => {
  if (typeof rawLink !== 'string') return rawLink;
  const trimmed = rawLink.trim();
  if (!/^https?:\/\//i.test(trimmed)) return rawLink;
  let url;
  try {
    url = new URL(trimmed);
  } catch {
    return rawLink;
  }
  if (!APP_MENU_PATH.test(url.pathname)) return rawLink;
  return `${url.pathname}${url.search}${url.hash}`;
};
